export default __webpack_public_path__ + "static/media/block-maps.aff59760.svg";